module.exports = __webpack_public_path__ + "img/person.e428ee66.png";